import { z } from 'zod';

const blankToNull = (value: unknown) => typeof value === 'string' && !value.trim() ? null : value;
const text = (max = 1000) => z.preprocess(blankToNull, z.string().trim().min(1).max(max).nullable()).optional();
const choice = z.preprocess(blankToNull, z.string().regex(/^(YES|NO)$/).nullable()).optional();
const money = z.preprocess(blankToNull, z.string().regex(/^(?:0|[1-9]\d{0,14})(?:\.\d{1,2})?$/).nullable()).optional();
const decimal = z.preprocess(blankToNull, z.string().regex(/^(?:0|[1-9]\d{0,8})(?:\.\d{1,6})?$/).nullable()).optional();
const temperature = z.preprocess(blankToNull, z.string().regex(/^-?(?:0|[1-9]\d{0,3})(?:\.\d{1,6})?$/).nullable()).optional();
const date = z.preprocess(blankToNull, z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine(value => {
  const parsed = new Date(value + 'T00:00:00Z');
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}, '请输入有效日期 YYYY-MM-DD。').nullable()).optional();

/** Optional fields preserve earlier revisions and immutable snapshots. */
export const originInspectionHeaderShape = {
  certificateNumber: text(200), exporter: text(), transportRoute: text(), officialUse: text(2000),
  exporterDeclaration: text(2000), declarationPlace: text(300), declarationDate: date, exporterSignature: text(),
  certificationStatement: text(2000), certificationPlace: text(300), certificationDate: date, certifyingAuthoritySignature: text(),
  issuedRetroactively: choice, thirdPartyInvoicing: choice,
  applicant: text(), commodity: text(2000), quantityWeight: text(500),
  inspectionItems: text(2000), inspectionResults: text(2000),
  sanitaryResults: text(2000),
  inspectionPlace: text(300), inspectionDate: date, inspectionSignature: text(),
  quantityPackages: text(500), fumigant: text(300), fumigantConcentration: decimal,
  fumigationDuration: decimal, fumigationTemperature: temperature,
  treatmentResult: text(2000), treatmentPlace: text(300), treatmentDate: date,
};
export const originInspectionItemShape = { invoiceNumber: text(200), invoiceDate: date, originCriterion: text(300), fobValue: money };
export const originInspectionTermNames = Object.keys(originInspectionHeaderShape) as (keyof typeof originInspectionHeaderShape)[];
export const originInspectionItemNames = Object.keys(originInspectionItemShape) as (keyof typeof originInspectionItemShape)[];
export type OriginInspectionTerms = z.output<z.ZodObject<typeof originInspectionHeaderShape>>;
export type OriginInspectionItem = z.output<z.ZodObject<typeof originInspectionItemShape>>;
